import type { MouseEventHandler } from "react";

import type { TWithDataComponent } from "@/ui/lib/types";

/*-------------------------------------
|  Types
-------------------------------------*/

export type TDeliveryDelayCardProps = TWithDataComponent & {
  expectedDelivery: string;
  alertText?: string;
  onDelay: MouseEventHandler<HTMLButtonElement>;
};

/*-------------------------------------
|  Defaults
-------------------------------------*/

export const DELIVERY_DELAY_CARD_DEFAULTS = {
  "data-component": "DeliveryDelayCard",
} as const;
